import React from 'react';

const SLA_2H = ['CIRURGIA BUCO MAXILO'];
const SLA_24H = ['ALERGIA E IMUNOLOGIA', 'ANESTESIOLOGIA', 'BRONCOSCOPIA', 'CARDIOLOGIA', 'CIRURGIA DO APARELHO DIGESTIVO', 'CIRURGIA TORACICA', 'FONOAUDIOLOGIA',
  'GERIATRIA', 'HEMATOLOGIA E HEMOTERAPIA', 'MEDICINA HIPERBARICA', 'NEUROLOGIA', 'ONCOLOGIA - INTERNO', 'ONCOLOGIA CIRURGI/CANCEROLOGIA', 'PSICOLOGIA', 'PSIQUIATRIA',
  'RADIOTERAPIA', 'REUMATOLOGIA', 'TIME DE PICC', 'UROLOGIA'
];
const SLA_48H = ['ARRITMOLOGIA', 'CIRURGIA CARDIOVASCULAR', 'CIRURGIA DE CABECA E PESCOCO', 'CIRURGIA DE COLUNA', 'CIRURGIA GERAL', 'CIRURGIA PEDIATRICA', 
  'CIRURGIA VASCULAR', 'CLINICA DA DOR', 'CLINICA GERAL', 'DERMATOLOGIA', 'ENDOCRINOLOGIA/METABOLOGIA', 'ENDOSCOPIA', 'ESTOMATERAPEUTA', 'GASTROENTEROLOGIA', 
  'GINECOLOGIA/OBSTETRICIA', 'GOC', 'HEMATOLOGIA PEDIATRICA', 'HEPATOLOGIA', 'INSUFICIENCIA CARDIACA AVANCAD', 'MASTOLOGIA', 'NEFROLOGIA', 'NEONATOLOGIA',
  'NEUROCIRURGIA', 'NEUROPEDIATRIA', 'ODONTOLOGIA', 'OFTALMOLOGIA', 'ONCOLOGIA - EXTERNO', 'ONCOLOGIA PEDIATRICA', 'OTORRINOLARINGOLOGIA', 'PNEUMOLOGIA/TISIOLOGIA',
  'RADIOLOGIA E DIAG POR IMAGEM'
];
const SLA_72H = ['ACUPUNTURA (TERAPEUTICA)', 'ANATOMOPATOLOGIA', 'ANGIOLOGIA', 'BIOQUIMICO/BIOLOGO/QUI/BIOMEDI', 'CARDIOLOGIA INTERVENCIONISTA', 'CARDIOLOGIA PEDIATRICA',
  'CIRURGIA BARIATRICA', 'CIRURGIA DA MAO', 'CIRURGIA PLASTICA', 'CIRURGIA ROBOTICA', 'CITOPATOLOGIA', 'DIAGNÓSTICO POR IMAGEM', 'ENFERMAGEM', 'ENFERMAGEM DO P.A.C.S',
  'ENFERMAGEM OBSTETRICIA', 'ENFERMEIRO (A) TERCEIROS', 'FARMACEUTICO', 'FISIATRIA', 'FISICO NUCLEAR', 'FISIOTERAPIA', 'GENETICA MEDICA', 'INATIVA', 'INFECTOLOGIA', 
  'INSTRUMENTAÇAO CIRURGICA', 'MEDICINA DA FAMILIA', 'MEDICINA DO TRABALHO', 'MEDICINA FISICA E REABILITACAO', 'MEDICINA GERAL', 'MEDICINA INTENSIVA', 'MEDICINA NUCLEAR',
  'ODONTOLOGIA PROTESE B.M.F.', 'ODONTORRADIOLOGIA', 'ORTOPEDIA/TRAUMATOLOGIA', 'PATOLOGIA', 'PATOLOGIA CLINICA/MEDICINA LAB', 'PEDIATRIA', 'PERFUSIONISTA',
  'PRE-REQUISITO AREA CIR BASICA', 'SOS ANESTESIOLOGIA', 'SOS CLINICA MEDICA REAVALIACAO', 'TECNICO DE ENFERMAGEM', 'TECNICO LABORATORIO NIVEL MEDI', 
  'TECNICO RADIOLOGIA NIVEL MEDIO', 'TERAPIA OCUPACIONAL', 'ZHEMATOLOGIA -EXTERNO'
];
const SLA_PERSONALIZADO = ['NUTRICIONISTA', 'NUTROLOGIA', 'COLOPROCTOLOGIA', 'PROCTOLOGIA'];

const ESPECIALIDADES_SLA = {
  'SLA_2H': SLA_2H,
  'SLA_24H': SLA_24H,
  'SLA_48H': SLA_48H,
  'SLA_72H': SLA_72H,
  'SLA_PERSONALIZADO': SLA_PERSONALIZADO
}

const REGRAS_SLA = {
	'SLA_2H': [
		{ cor: 'VERDE', limite: 60 },
		{ cor: 'AMARELO', limite: 120 },
		{ cor: 'VERMELHO', limite: null },
	],
	'SLA_24H': [
		{ cor: 'VERDE', limite: 720 },
		{ cor: 'AMARELO', limite: 1440 },
		{ cor: 'VERMELHO', limite: null },
	],
	'SLA_48H': [
		{ cor: 'VERDE', limite: 1440 },
		{ cor: 'AMARELO', limite: 2880 },
		{ cor: 'VERMELHO', limite: null },
	],
	'SLA_72H': [
		{ cor: 'VERDE', limite: 2160 },
		{ cor: 'AMARELO', limite: 4320 },
		{ cor: 'VERMELHO', limite: null },
	],
	'SLA_PERSONALIZADO': {
    'NUTRICIONISTA' : {
      'COMERCIAL' : [
        { cor: 'VERDE', limite: 60 },
        { cor: 'AMARELO', limite: 120 },
        { cor: 'VERMELHO', limite: null },
      ],
      'NOTURNO' : [
        { cor: 'VERDE', limite: 360 },
        { cor: 'AMARELO', limite: 720 },
        { cor: 'VERMELHO', limite: null },
      ],
    },
    'NUTROLOGIA' : {
      'COMERCIAL' : [
        { cor: 'VERDE', limite: 60 },
        { cor: 'AMARELO', limite: 120 },
        { cor: 'VERMELHO', limite: null },
      ],
      'NOTURNO' : [
        { cor: 'VERDE', limite: 360 },
        { cor: 'AMARELO', limite: 720 },
        { cor: 'VERMELHO', limite: null },
      ],
    },
    'COLOPROCTOLOGIA' : {
      'UTI' : [
        { cor: 'VERDE', limite: 720 },
        { cor: 'AMARELO', limite: 1440 },
        { cor: 'VERMELHO', limite: null },
      ],
      'ENFERMARIA' : [
        { cor: 'VERDE', limite: 1440 },
        { cor: 'AMARELO', limite: 2880 },
        { cor: 'VERMELHO', limite: null },
      ],
    },
    'PROCTOLOGIA' : {
      'UTI' : [
        { cor: 'VERDE', limite: 720 },
        { cor: 'AMARELO', limite: 1440 },
        { cor: 'VERMELHO', limite: null },
      ],
      'ENFERMARIA' : [
        { cor: 'VERDE', limite: 1440 },
        { cor: 'AMARELO', limite: 2880 },
        { cor: 'VERMELHO', limite: null },
      ],
    },
  }
}

export const buscarCorSLA = ({ especialidade, tempoParecer, dataParecer, leito }) => {
  const corDefault = 'VERDE';
  const regraDefault = 'SLA_72H';
  let tempoSLA = null;

  let regraSLA = Object.keys(ESPECIALIDADES_SLA).find(key => ESPECIALIDADES_SLA[key].includes(especialidade));

  if (!regraSLA) {
    regraSLA = regraDefault;
  }  
  
  if (regraSLA == 'SLA_PERSONALIZADO') {
    let tipo = null;
    if (['NUTRICIONISTA', 'NUTROLOGIA'].includes(especialidade)) {
      const horarioParecer = new Date(dataParecer);
      const minutosTotais = (horarioParecer.getHours() * 60) + horarioParecer.getMinutes();
      const inicioHorario = 7 * 60;    // 07:00 em minutos (420)
      const fimHorario = 19 * 60;      // 19:00 em minutos (1140)

      if (minutosTotais >= inicioHorario && minutosTotais < fimHorario) {
        tipo = 'COMERCIAL';
      } else {
        tipo = 'NOTURNO';
      }
    }

    if (['COLOPROCTOLOGIA', 'PROCTOLOGIA'].includes(especialidade)) {
      if (leito?.includes('UTI')) {
        tipo = 'UTI';
      } else {
        tipo = 'ENFERMARIA';
      }
    }

    if (!tipo) return corDefault;
    
    tempoSLA = REGRAS_SLA.SLA_PERSONALIZADO[especialidade]?.[tipo];
  } else {
    tempoSLA = REGRAS_SLA[regraSLA];
  }

  if (!Array.isArray(tempoSLA) || tempoSLA.length === 0) {
    return corDefault;
  }

  for (const { cor, limite } of tempoSLA) {
    if (limite === null || tempoParecer < limite) {
      return cor;
    }
  }

  return corDefault;
};